import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommentReactionComponent } from './comment-reaction.component';

@NgModule({
  declarations: [CommentReactionComponent],
  exports: [CommentReactionComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class CommentReactionModule {}
